// extracted by mini-css-extract-plugin
export default {"wrapper":"EditEmailTemplates_wrapper__RjD11","preview":"EditEmailTemplates_preview__DKN70"};